<form [formGroup]="formGroup" autocomplete="off" class="report-options-form">
    <div class="settings-subheading">Page</div>

    <div class="field-block">
        <label class="field-label">Orientation</label>
        <mat-form-field appearance="outline" class="full-width">
            <mat-select formControlName="pageOrientation">
                <mat-option value="portrait">Portrait</mat-option>
                <mat-option value="landscape">Landscape</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <mat-divider class="settings-divider"></mat-divider>

    <div class="settings-subheading">Font</div>

    <div class="field-block">
        <label class="field-label">Font family</label>
        <mat-form-field appearance="outline" class="full-width">
            <mat-select
                formControlName="fontFamily"
                placeholder="Select a font"
            >
                <mat-option>
                    <ngx-mat-select-search
                        [formControl]="fontFilterControl"
                        placeholderLabel="Search fonts…"
                        noEntriesFoundLabel="No fonts found"
                    >
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option
                    *ngFor="let font of filteredFonts$ | async"
                    [value]="font"
                    [style.fontFamily]="font"
                >
                    {{ font }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="settings-subheading">Grid</div>

    <div class="field-block">
        <label class="field-label">Grid density</label>
        <mat-form-field appearance="outline" class="full-width">
            <mat-select [formControl]="densityControl">
                <mat-option [value]="1">Standard (1&times;)</mat-option>
                <mat-option [value]="2">Dense (2&times;)</mat-option>
            </mat-select>
            <mat-hint
                >Finer placement grid; your existing layout is
                preserved.</mat-hint
            >
        </mat-form-field>
    </div>

    <div class="field-block">
        <label class="field-label">Margin</label>
        <mat-form-field appearance="outline" class="full-width">
            <input
                matInput
                type="number"
                min="0"
                max="5"
                step="1"
                [formControl]="marginControl"
            />
            <span matSuffix>cells</span>
            <mat-hint
                >Visual guide only (shown while editing); doesn't restrict
                placement. Max 5.</mat-hint
            >
        </mat-form-field>
    </div>

    <div class="field-block">
        <label class="field-label">Grid visibility</label>
        <div class="chip-row">
            <button
                type="button"
                class="opt-chip"
                [class.active]="visibilityControl.value === DisplayGrid.Always"
                [attr.aria-pressed]="visibilityControl.value === DisplayGrid.Always"
                (click)="visibilityControl.setValue(DisplayGrid.Always)"
            >
                Always
            </button>
            <button
                type="button"
                class="opt-chip"
                [class.active]="visibilityControl.value === DisplayGrid.OnDragAndResize"
                [attr.aria-pressed]="visibilityControl.value === DisplayGrid.OnDragAndResize"
                (click)="visibilityControl.setValue(DisplayGrid.OnDragAndResize)"
            >
                While dragging
            </button>
            <button
                type="button"
                class="opt-chip"
                [class.active]="visibilityControl.value === DisplayGrid.None"
                [attr.aria-pressed]="visibilityControl.value === DisplayGrid.None"
                (click)="visibilityControl.setValue(DisplayGrid.None)"
            >
                Hidden
            </button>
        </div>
    </div>

</form>